import { Flex, Spin } from 'antd';
import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { AdminPageWrapper } from 'components/layouts/AdminPageWrapper';
import { ReactNode } from 'react';

type AdminErrorPageProps = {
  isRefetching?: boolean;
  refetch?: () => void;
  error?: ReactNode;
};

export const AdminErrorPage = ({
  isRefetching,
  refetch,
  error = 'Something went wrong',
}: AdminErrorPageProps) => (
  <AdminPageWrapper>
    <Flex vertical gap={16} align='center'>
      {error}
      {refetch && (
        <>
          {isRefetching ? (
            <Spin />
          ) : (
            <div>
              <ButtonComponent
                label='Retry'
                onClick={() => {
                  refetch();
                }}
                appereance='secondary'
                size='middle'
              />
            </div>
          )}
        </>
      )}
    </Flex>
  </AdminPageWrapper>
);
